import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=6883bb9c&"
import script from "./menuManage.vue?vue&type=script&lang=js&"
export * from "./menuManage.vue?vue&type=script&lang=js&"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=6883bb9c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports